import { Injectable } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class Routes {
	public readonly Home: string = "/Home";
	public readonly UserManagement: string = "/Home/UserManagement";
	public readonly AddUser: string = "/Home/UserManagement/addUser";
	public readonly Account: string = "/Home/Profile";
	public readonly ChangeSession: string = "/Home/ChangeSession";
	public readonly Navigate: string = "/Home/Navigate";
	public readonly Settings: string = "/Home/Settings";
	public readonly SystemAdmin: string = "/Home/SystemAdmin";

	public readonly KeepAliveReports: string = "/KeepAlive/Reports";
	public readonly CDRDeviceUsageReport: string = "/Reports/1";
	public readonly Reports: string = "/Reports";

	public readonly CDR: string = "/CDR";
	public readonly CDRDashboard: string = "/CDR/Dashboard";
	public readonly CDRDevices: string = "/CDR/Devices";
	public readonly CDRDeviceDetails: string = "/CDR/Devices/Details";
	public readonly CDRAlerts: string = "/CDR/Alerts";
	public readonly CDRMap: string = "/CDR/Map";

	public readonly Relay: string = "/Relay";
	public readonly RelayDashboard: string = "/Relay/Dashboard";
	public readonly RelayPortsManagement: string = "/Relay/Dashboard/PortsManagement";

	public readonly Releases: string = "/Releases";

	public readonly KeepAlive: string = "/KeepAlive";
	public readonly KeepAliveDashboard: string = "/KeepAlive/Dashboard";
	public readonly KeepAliveDevices: string = "/KeepAlive/Devices";
	public readonly KeepAliveDeviceDetails: string = "/KeepAlive/Devices/Details";
	public readonly KeepAliveMap: string = "/KeepAlive/Map";
	public readonly KeepAliveRingfenceLogs: string = "/KeepAlive/RingfenceLogs";

	public readonly Mikrotik: string = "/Mikrotik";
	public readonly MikrotikDashboard: string = "/Mikrotik/Dashboard";
	public readonly MikrotikDevices: string = "/Mikrotik/Devices";
	public readonly MikrotikDeviceDetails: string = "/Mikrotik/Devices/Details";
	public readonly MikrotikMap: string = "/Mikrotik/Map";

	public readonly Teltonika: string = "/Teltonika/Dashboard";
	public readonly TeltonikaDashboard: string = "/Teltonika/Dashboard";
	public readonly TeltonikaReporting: string = "/Teltonika/Reporting";

	public readonly Contractors: string = "/Contractors";


	public readonly UpdateUser = (id: number) => {
		return `/Home/UserManagement/addUser/${id}`;
	};
}
